export enum UnderwearType {
    Knickers = 'Knickers',
    GrannyKnickers = 'Granny Knickers',
    String = 'String'
}
